import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateFavoriteAppraisalsMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  favorite: Types.Scalars['Boolean']['input'];
}>;


export type UpdateFavoriteAppraisalsMutation = { __typename?: 'mutation_root', update_appraisals?: { __typename?: 'appraisals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'appraisals', id: number, favorite: boolean }> } | null };


export const UpdateFavoriteAppraisalsDocument = gql`
    mutation updateFavoriteAppraisals($id: bigint!, $favorite: Boolean!) {
  update_appraisals(where: {id: {_eq: $id}}, _set: {favorite: $favorite}) {
    affected_rows
    returning {
      id
      favorite
    }
  }
}
    `;
export type UpdateFavoriteAppraisalsMutationFn = Apollo.MutationFunction<UpdateFavoriteAppraisalsMutation, UpdateFavoriteAppraisalsMutationVariables>;

/**
 * __useUpdateFavoriteAppraisalsMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteAppraisalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteAppraisalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteAppraisalsMutation, { data, loading, error }] = useUpdateFavoriteAppraisalsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useUpdateFavoriteAppraisalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteAppraisalsMutation, UpdateFavoriteAppraisalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteAppraisalsMutation, UpdateFavoriteAppraisalsMutationVariables>(UpdateFavoriteAppraisalsDocument, options);
      }
export type UpdateFavoriteAppraisalsMutationHookResult = ReturnType<typeof useUpdateFavoriteAppraisalsMutation>;
export type UpdateFavoriteAppraisalsMutationResult = Apollo.MutationResult<UpdateFavoriteAppraisalsMutation>;
export type UpdateFavoriteAppraisalsMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteAppraisalsMutation, UpdateFavoriteAppraisalsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/updateFavoriteAppraisals.mutation.gql}
 */
export async function updateFavoriteAppraisals(
  variables: UpdateFavoriteAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateFavoriteAppraisalsMutation['update_appraisals']>
export async function updateFavoriteAppraisals(
  variables: UpdateFavoriteAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateFavoriteAppraisalsMutation>
export async function updateFavoriteAppraisals(
  variables: UpdateFavoriteAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateFavoriteAppraisalsMutation['update_appraisals'] | UpdateFavoriteAppraisalsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateFavoriteAppraisalsMutation>(
    UpdateFavoriteAppraisalsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_appraisals
}